export default __webpack_public_path__ + "static/media/copy-blue.fa8b8eca.svg";